module.exports = __webpack_public_path__ + "img/aboutUs62024.0dec38f.png";